export default "__VITE_ASSET__DU1neXsh__"